import { render, staticRenderFns } from "./AppointmentActionMenu.vue?vue&type=template&id=5dbd4faa"
import script from "./AppointmentActionMenu.vue?vue&type=script&lang=ts"
export * from "./AppointmentActionMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports